import type { AppRouteRecordRaw, AppRouteModule } from '@/router/types';
import { FORBIDDEN_ROUTE, PAGE_NOT_FOUND_ROUTE } from '@/router/routes/basic';
// import { mainOutRoutes } from './mainOut'
import { PageEnum } from '@/enums/pageEnum';
import { t } from '@/hooks/web/useI18n';
import { LAYOUT } from '@/router/constant';

// import.meta.glob() 直接引入所有的模块 Vite 独有的功能
const modules = import.meta.glob('./modules2/**/*.ts', { eager: true });
const routeModuleList: AppRouteModule[] = [];

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
  const mod = (modules as Recordable)[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

// 根路由
export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: import.meta.env.MODE == 'web' ? '/login' : PageEnum.PERMISSION,
  meta: {
    title: 'Root'
  }
};

export const PermissionRoute: AppRouteRecordRaw = {
  path: '/permission',
  name: 'Permission',
  meta: {
    title: 'Permission'
  },
  component: () => import('@/views/sys/permission/index.vue')
};

// 登录路由
export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/loginNew.vue'),
  meta: {
    title: t('routes.basic.login')
  }
};

export const LoginRoute2: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/loginNew.vue'),
  meta: {
    title: t('routes.basic.login')
  }
};

export const AuthRoute: AppRouteRecordRaw = {
  path: '/auth',
  name: 'Auth',
  component: () => import('@/views/auth/index.vue'),
  meta: {
    title: t('routes.basic.auth')
  }
};

export const AdLoginRoute: AppRouteRecordRaw = {
  path: '/adlogin',
  name: 'AdLogin',
  component: () => import('@/views/adLogin/index.vue'),
  meta: {
    title: t('routes.basic.auth')
  }
};

export const AboutMyKone: AppRouteRecordRaw = {
  path: '/about-myKONE',
  name: 'AboutMyKone',
  component: LAYOUT,
  meta: {
    title: t('aboutMyKone.aboutMyKone'),
    hideBreadcrumb: true,
    hideMenu: false,
    orderNo: 10,
    layout: 'empty',
    master: true
  },
  children: [
    {
      path: '/about-myKONE',
      name: 'AboutMyKoneIndex',
      component: () => import('@/views/aboutMyKone/index.vue'),
      meta: {
        title: t('aboutMyKone.aboutMyKone'),
        hideBreadcrumb: true,
        hideMenu: false,
        master: true,
        layout: 'empty'
      }
    }
  ]
};

export const StartPage: AppRouteRecordRaw = {
  path: '/startPage',
  name: 'StartPage',
  component: () => import('@/views/sys/startPage/index.vue'),
  meta: {
    title: t('startPage.pageTitle')
  }
};

// Basic routing without permission
// NOTE: 根据具体 ui 需要路由进行变化，而且路由的权限问题还没确定下来
export const basicRoutes = [
  RootRoute,
  PermissionRoute,
  // ...(import.meta.env.VITE_BUILD_TARGET === 'dev' ? [LoginRoute] : [LoginRoute2]),
  LoginRoute2,
  // LoginRoute,
  AdLoginRoute,
  AboutMyKone,
  StartPage,
  FORBIDDEN_ROUTE,
  ...routeModuleList,
  PAGE_NOT_FOUND_ROUTE
];
